import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useTheme } from '@/shared/providers/theme/ThemeContext';
import { useClinicContext } from '@/hooks/main/useClinicContext';
import {
  fetchTreatmentRecordPrintInit,
  createTreatmentRecordPrintPreviewTicket,
  type TreatmentRecordPrintPayload,
} from '@/pages/main/consent/services/print';

export const useTreatmentRecordPrintInit = (patientId: number, consentId: number, enabled = true) => {
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();

  return useQuery({
    queryKey: ['treatment-record-print', 'init', tenant, clinicNumber, patientId, consentId, serviceType],
    queryFn: () => fetchTreatmentRecordPrintInit(tenant, clinicNumber, patientId, consentId, serviceType),
    enabled: enabled && !!patientId && !!consentId,
  });
};

export const useTreatmentRecordPrintOutput = (patientId: number, consentId: number) => {
  const queryClient = useQueryClient();
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();

  return useMutation({
    mutationFn: (payload: TreatmentRecordPrintPayload) =>
      createTreatmentRecordPrintPreviewTicket(
        tenant,
        clinicNumber,
        patientId,
        consentId,
        payload,
        serviceType
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['treatment-record-print', 'init', tenant, clinicNumber, patientId, consentId, serviceType],
      });
    },
  });
};
